import { render } from "./incluirInteracao.vue?vue&type=template&id=3e09db0b&scoped=true"
import script from "./incluirInteracao.vue?vue&type=script&lang=js"
export * from "./incluirInteracao.vue?vue&type=script&lang=js"

import "./incluirInteracao.vue?vue&type=style&index=0&id=3e09db0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e09db0b"]])

export default __exports__